module.exports = __webpack_public_path__ + "img/Dai3-3p2.1256d7dc.png";